import React from "react";
import { useSelector } from "react-redux";
import { Modal, ModalBody, ModalHeader, Table } from "reactstrap";
import { readableDate } from "utils";

const ExpenseDetail = (props: any) => {
  const { expense, isOpen, toggle } = props;
  console.log("Expense Details: ", expense);
  const defaultCurrency = useSelector(
    (state: any) => state.Login.default_currency
  );

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle}>
        <h5 className="modal-title">Expense Details</h5>
      </ModalHeader>
      <ModalBody>
        <div className="mb-4">
          <div className="table-responsive">
            <Table className="table-borderless mb-0">
              <tbody>
                <tr>
                  <th scope="row" style={{ width: "200px" }}>
                    Expense ID :
                  </th>
                  <td>#{expense?.id}</td>
                </tr>
                <tr>
                  <th scope="row">Description:</th>
                  <td>{expense?.description}</td>
                </tr>
                <tr>
                  <th scope="row">Amount:</th>
                  <td>
                    {defaultCurrency} {expense?.amount?.toFixed(2)}
                  </td>
                </tr>
                <tr>
                  <th scope="row">Category:</th>
                  <td>{expense?.category?.name}</td>
                </tr>
                <tr>
                  <th scope="row">Created by:</th>
                  <td>{expense?.created_by_user?.email}</td>
                </tr>
                <tr>
                  <th scope="row">Date:</th>
                  <td>{readableDate(expense?.date)}</td>
                </tr>
              </tbody>
            </Table>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default ExpenseDetail;
